import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  Router,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { DoctorSRVService } from '../doctor-srv.service';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidemenuComponent implements OnInit, AfterViewInit {

  hcp: any;

  constructor(
    private router: Router,
    private service: DoctorSRVService,
    public app: AppService,
    private toaster: ToastrService,
    private cd: ChangeDetectorRef,
  ) {

  }

  ngOnInit(): void {
    this.getHcpById();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }



  getHcpById = () => {
    this.service.getHcpById(this.app.getUserData().id).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.hcp = res.data
          this.cd.detectChanges();
        }
      }
    )
  }
}
